/* Predictive search for the search dialog (snippets/overlays.liquid).
   Renders sections/predictive-search.liquid through the Section Rendering API,
   so suggestions use the same product cards as collections and search results.
   Replaces the older JSON dropdown in essaint.js: the input is swapped for a
   clean copy (same id, so the header button still focuses it) which drops that
   listener. Searches title, product type, tags, variant titles (colours) and vendor. */
(() => {
  'use strict';
  const old = document.getElementById('search-input');
  const box = document.getElementById('search-results');
  if (!old || !box || old.dataset.ps) return;
  const input = old.cloneNode(true);
  input.dataset.ps = '1';
  old.replaceWith(input);

  const root = (window.Essaint && window.Essaint.root) || '/';
  const fields = 'title,product_type,tag,variants.title,vendor';
  let timer, ctrl;

  // "Essaint" is on every piece, so it only crowds the 10 suggestions; drop it
  // unless it is the whole query.
  const lookup = q => q.replace(/\bessaint\b/gi, ' ').replace(/\s+/g, ' ').trim() || q;

  const run = async q => {
    if (ctrl) ctrl.abort();
    ctrl = new AbortController();
    const url = root + 'search/suggest?q=' + encodeURIComponent(lookup(q)) +
      '&resources[type]=product&resources[limit]=10' +
      '&resources[options][unavailable_products]=last' +
      '&resources[options][fields]=' + fields +
      '&section_id=predictive-search';
    try {
      const html = await fetch(url, { signal: ctrl.signal }).then(r => {
        if (!r.ok) throw new Error(r.status);
        return r.text();
      });
      if (input.value.trim() !== q) return;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const res = doc.getElementById('predictive-search-results');
      box.innerHTML = res ? res.innerHTML : '';
    } catch (e) {
      if (e.name === 'AbortError') return;
      box.innerHTML = '<p class="ps-note">Suggestions are unavailable right now. Press Search to see all results.</p>';
    }
  };

  input.addEventListener('input', () => {
    clearTimeout(timer);
    const q = input.value.trim();
    if (q.length < 2) { if (ctrl) ctrl.abort(); box.innerHTML = ''; return; }
    timer = setTimeout(() => run(q), 220);
  });
})();
